import { useMutation } from "react-query";
import { useHistory } from "react-router-dom";
import invariant from "tiny-invariant";
import { broadcastsApi } from "@/react/api/broadcastsApi";
import { useEmailMarketingTemplatePaths } from "@/react/components/shared/Emails/Templates/TemplatePathContext";
import { queryClient } from "@/react/providers/QueryClient";
import type { MarketingEmailTemplateContentType } from "@/react/types/MarketingEmailTemplates";
import { useBroadcastData } from "@circle-react-shared/Emails/BroadcastDataContext";
import { getBroadcastQueryKey } from "./useGetBroadcast";

export const useResetBroadcastContent = () => {
  const {
    mutateAsync: resetBroadcastContent,
    isLoading: isResettingBroadcastContent,
  } = useMutation(broadcastsApi.resetContent);
  const { data: broadcast } = useBroadcastData();
  const history = useHistory();
  const { visualBuilderPath, contentPath } = useEmailMarketingTemplatePaths();

  const handleResetBroadcastContent = async (
    templateContentType: MarketingEmailTemplateContentType,
  ) => {
    invariant(broadcast, "Broadcast is required");
    return resetBroadcastContent(
      { id: broadcast.id },
      {
        onSuccess: async () => {
          const path =
            templateContentType === "visual_email_builder"
              ? visualBuilderPath
              : contentPath;

          await queryClient.invalidateQueries(
            getBroadcastQueryKey(broadcast.id),
          );
          history.push(path);
        },
      },
    );
  };

  return {
    handleResetBroadcastContent,
    isResettingBroadcastContent,
  };
};
